import { render, staticRenderFns } from "./guide.vue?vue&type=template&id=71347d2c&scoped=true"
import script from "./guide.vue?vue&type=script&lang=js"
export * from "./guide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71347d2c",
  null
  
)

export default component.exports